import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { encryptedKeyByAesKeyValidator, encryptedKeyByRsaKeyValidator, hashValidator, } from '#validation';
export const DomainCryptoRequestSchema = z.object({
    eDomainKeyByAdminKey: encryptedKeyByRsaKeyValidator,
    eSsoSecretByDomainKey: encryptedKeyByAesKeyValidator,
    domainHash: hashValidator,
});
export class DomainCryptoRequestDto extends createZodDto(DomainCryptoRequestSchema) {
}
